module.exports = __webpack_public_path__ + "img/athena_carousel_03.ab0b0713.jpg";